import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';

const toDateValue = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === 'function') return value.toDate();
  if (value instanceof Date)
    return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'object') {
    const rawSeconds =
      value._seconds ?? value.seconds ?? value.sec ?? value.epochSeconds;
    if (rawSeconds != null) {
      const seconds = Number(rawSeconds);
      const nanos = Number(value._nanoseconds ?? value.nanoseconds ?? 0);
      if (!Number.isNaN(seconds) && !Number.isNaN(nanos)) {
        const parsed = new Date(seconds * 1000 + Math.floor(nanos / 1000000));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
    }
  }

  if (typeof value === 'string') {
    const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return new Date(Number(year), Number(month) - 1, Number(day));
    }
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  return null;
};

const formatDate = (value) => {
  const date = toDateValue(value);
  if (!date) return '';
  const formattedDay = String(date.getDate()).padStart(2, '0');
  const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${formattedDay}-${formattedMonth}-${year}`;
};

export const columnConfig = ({ teamProjects, memberDetails }) => {
  return [
    {
      id: 'id',
      name: 'ID',
      sortable: false,
      cellRenderer: (row, rowIndex) => {
        return <div>{rowIndex + 1}</div>;
      },
    },
    {
      id: 'project',
      name: 'Project',
      sortable: false,
      cellRenderer: (row) => {
        const project = teamProjects.find((p) => p.id === row.projectId);
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {project?.data?.project_name || 'N/A'}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'taskName',
      name: 'Task Name',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row.taskName || 'N/A'}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'taskTime',
      name: 'Task Time',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >{`${row.taskHours || 0}h ${row.taskMinutes || 0}m`}</Text>
          </div>
        );
      },
    },
    {
      id: 'taskDate',
      name: 'Task Date',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {formatDate(row.startTime)}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'department',
      name: 'Department',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row.teamName || 'N/A'}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'reportDate',
      name: 'Report Date',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {formatDate(row.createdAt || row.requestDate)}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'assignee',
      name: 'Assignee',
      sortable: false,
      cellRenderer: (row) => {
        const m = memberDetails?.[row.assignee];
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {m?.userName || m?.userEmailid || row.assignee || ''}
            </Text>
          </div>
        );
      },
    },
    {
      id: 'status',
      name: 'Status',
      sortable: false,
      cellRenderer: (row) => {
        return (
          <div>
            <Text
              variant={textVariantsEnum.Text_sm}
              fontWeight={fontWeightEnum.Medium}
            >
              {row.status}
            </Text>
          </div>
        );
      },
    },
  ];
};
